/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { List, fromJS } from 'immutable';
import { RestAPI } from '../../../../util/net';
import { putError } from '../../../../store/error.store';

const addFields = (data) => data.set('label', data.get('name')).set('value', data.get('id'));

export const buyerCarinsuranceReducer = (state = List(), action) => {
  switch (action.type) {
    case 'BUYER_CAR_INSURANCE_LOADED':
      return fromJS(action.data).map(d => addFields(d));
    case 'BUYER_CAR_INSURANCE_UPDATED': {
      let newState = state;
      if (action.toAddInsurance && action.toAddInsurance.length) {
        // eslint-disable-next-line
        action.toAddInsurance.forEach(toAdd => newState = newState.push(fromJS(toAdd)));
      }
      if (action.toRemoveInsurance && action.toRemoveInsurance.length) {
        // eslint-disable-next-line
        action.toRemoveInsurance.forEach(toRemove =>
          newState = newState.filter(val => val.get('id') !== toRemove.id));
      }
      return newState;
    }
    default:
      return state;
  }
};

export const loadCarInsurance = (dispatch) => {
  dispatch({ type: 'BUYER_CAR_INSURANCE_LOADING' });
  return RestAPI.get('/references/buyer/api/carinsurance')
    .then((data) => { dispatch({ type: 'BUYER_CAR_INSURANCE_LOADED', data }); return true; })
    .catch((data) => {
      putError(dispatch, data);
      dispatch({ type: 'BUYER_CAR_INSURANCE_LOADING_FAILED' });
      return true;
    });
};

const appendData = (formData, name, data) => {
  formData.append(name, new Blob([JSON.stringify(data)], { type: 'application/json' }));
};

export const updateCarInsurance = (dispatch, toAddInsurance, toRemoveInsurance) => {
  const formData = new FormData();
  appendData(formData, 'toAddInsurance', toAddInsurance.map(v => v.value));
  appendData(formData, 'toRemoveInsurance', toRemoveInsurance.map(v => v.value));
  dispatch({ type: 'BUYER_CAR_INSURANCE_UPDATE_STARTED' });
  return RestAPI.post('/references/buyer/api/carinsurance/update', formData, false, true)
    .then(() => {
      dispatch({ type: 'BUYER_CAR_INSURANCE_UPDATED',
        toAddInsurance, toRemoveInsurance }); return true;
    })
    .catch((data) => {
      putError(dispatch, data);
      dispatch({ type: 'BUYER_CAR_INSURANCE_UPDATE_FAILED' });
      return true;
    });
};
